import { render } from "./BuyDomain.vue?vue&type=template&id=07752696"
import script from "./BuyDomain.vue?vue&type=script&lang=js"
export * from "./BuyDomain.vue?vue&type=script&lang=js"

import "./BuyDomain.vue?vue&type=style&index=0&id=07752696&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__